window._ = require('lodash');

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');
    window.Swal = require('sweetalert2');
    //require('overlayscrollbars');
    require('bootstrap');
    require('datatables.net-bs4');
    require('gasparesganga-jquery-loading-overlay')
    require('bootstrap-chosen/dist/chosen.jquery-1.4.2/chosen.jquery');
    require('../../vendor/almasaeed2010/adminlte/dist/js/adminlte');
    require('dropify');
    require('jquery-ui/ui/widgets/autocomplete');
    require('bootstrap-datepicker/js/bootstrap-datepicker');
    require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.es.min.js')

} catch (e) {
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
